if (localStorage.getItem("klavyioPopupOpen") !== "true") {
  const popupId = window.klaviyoPopupId;
  console.log(popupId)
  if (popupId) {
    const handleScroll = () => {
      if (window.scrollY < 300) return;

      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(["openForm", popupId]);

      localStorage.setItem("klavyioPopupOpen", "true");
      document.removeEventListener("scroll", handleScroll);
    }
    document.addEventListener("scroll", handleScroll);
  }
}
